import { IProducts } from "@/api/AppApi/services/home/interfaces/IProduct";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import ProductBox from "../product-box/ProductBox";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";

interface Props {
  products: IProducts;
  setIslastProduct?: (isLastProduct: boolean) => void;
  scrollableTabs?: boolean;
  theme: ITheme;
  showCustomEventData?: boolean;
}
const ProductGrid: React.FC<Props> = ({
  products,
  scrollableTabs,
  theme,
  showCustomEventData,
}) => {
  const productSize = products.configurations?.style_type!;
  const isSmall =
    productSize === Size.small || productSize === Size.vertical_small;
  const gridClaaName = `product-grid-${isSmall ? "small" : "large"}${
    scrollableTabs ? "-scrollable-tabs" : ""
  }`;
  return (
    <div className={gridClaaName}>
      {products?.data.map((single, key) => (
        <ProductBox
          theme={theme}
          key={key}
          size={products.configurations?.style_type!}
          {...single}
          scrollableTabs={scrollableTabs!}
          priority={key < 0}
          Customize={products.configurations?.customize}
          isGrid
          showCustomEventData={showCustomEventData}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
